import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "../gallery/gallery.css";
import GalleryImg1 from "../../assets/images/gallery/g1.jpg";
import GalleryImg3 from "../../assets/images/gallery/g2.jpg";
import GalleryImg4 from "../../assets/images/gallery/g3.jpg";
import GalleryImg6 from "../../assets/images/gallery/g4.png";
import GalleryImg7 from "../../assets/images/gallery/g6.png";

const images = [
  { src: GalleryImg1 },
  { src: GalleryImg3 },
  { src: GalleryImg6 },
  { src: GalleryImg4 },
  { src: GalleryImg7 },
  { src: GalleryImg3 },
];

const Gallery = () => {
  const [index, setIndex] = useState(-1);

  return (
    <>
      <div className="masonry-gallery">
        {images.map((img, i) => (
          <img
            key={i}
            src={img.src}
            alt=""
            onClick={() => setIndex(i)}
            className="masonry-item"
          />
        ))}
      </div>

      <Lightbox
        open={index >= 0}
        close={() => setIndex(-1)}
        index={index}
        slides={images}
      />
    </>
  );
};

export default Gallery;
